// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__22khi","text":"SelectPayment_text__25dNN","title":"SelectPayment_title__3qt7G","btn":"SelectPayment_btn__JTvy5"};